// extracted by mini-css-extract-plugin
module.exports = {"value":"ContentValue_value__GUxz0","value_des":"ContentValue_value_des__Yp5Pq"};